import { counselorDocumentsApi } from "@/api";
import { HANDLE_ERROR_LOCALLY_HEADER } from "@/api/middleware/errorMiddleware";
import { QueryKey } from "@/query/Query";

import { useDropzoneUploadMutation } from "./useDropzoneUploadMutation";

const MUTATION_KEY = ["dropzone-upload"];

export function useDropZoneUpload() {
  return useDropzoneUploadMutation({
    mutationKey: MUTATION_KEY,
    uploadFn: async (file, convertToPdf) => {
      const formData = new FormData();
      formData.append("file", file);
      await counselorDocumentsApi.uploadDocumentToCounselorDropZone(
        { convertToPdf },
        { body: formData, headers: { [HANDLE_ERROR_LOCALLY_HEADER]: "true" } }
      );
    },
    invalidationKeys: [[QueryKey.DropZoneFiles]],
  });
}
